import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-white mx-4",
  style: {"font-size":"14px"}
}
const _hoisted_2 = {
  class: "text-white mx-4 my-1",
  style: {"font-size":"14px"}
}

import { computed } from "vue";
import { useAlertStore } from "@/shared/store/alert_store";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertComponent',
  setup(__props) {

const alertStore = useAlertStore();

const dialogConfig = computed(() => alertStore.alertDialogConfig);
const isFeedbackDialog = computed(
  () => dialogConfig.value?.variant === "feedback"
);

const handleConfirm = () => {
  alertStore.emitAlertDialogEvent(true);
  alertStore.hideAlertDialog();
};

const handleCancel = () => {
  alertStore.emitAlertDialogEvent(false);
  alertStore.hideAlertDialog();
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: _unref(alertStore).isAlertDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(alertStore).isAlertDialogVisible) = $event)),
      "max-width": "640",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "alert-dialog-card rounded-xl pa-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 text-center font-weight-bold pa-0" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dialogConfig.value?.title), 1)
              ]),
              _: 1
            }),
            (dialogConfig.value?.message)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "text-body-2 text-center mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(dialogConfig.value.message), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "justify-center mt-6" }, {
              default: _withCtx(() => [
                (!isFeedbackDialog.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "outlined",
                      class: "alert-dialog-btn alert-dialog-btn-cancel",
                      onClick: handleCancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(dialogConfig.value?.cancelLabel), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "alert-dialog-btn alert-dialog-btn-confirm",
                  onClick: handleConfirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(dialogConfig.value?.confirmLabel), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(alertStore).getTypeAlert)
      ? (_openBlock(), _createBlock(_component_v_snackbar, {
          key: 0,
          modelValue: _unref(alertStore).isDialogVisible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(alertStore).isDialogVisible) = $event)),
          color: "success",
          timeout: "4000",
          class: "v-snack-bar",
          "multi-line": "",
          rounded: "lg",
          "max-width": "150px",
          onClick: _unref(alertStore).hideDialogAlert
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(alertStore).getAlertMessage), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onClick"]))
      : (_openBlock(), _createBlock(_component_v_snackbar, {
          key: 1,
          modelValue: _unref(alertStore).isDialogVisible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(alertStore).isDialogVisible) = $event)),
          color: "error",
          timeout: "4000",
          class: "v-snack-bar",
          "multi-line": "",
          rounded: "lg",
          "max-width": "150px",
          onClick: _unref(alertStore).hideDialogAlert
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", {
                  class: "text-white mx-4",
                  style: {"font-size":"18px"}
                }, "Atenção:", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(alertStore).getAlertMessage), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onClick"]))
  ], 64))
}
}

})